import React, { Fragment } from "react";
import Navbar from "../../components/Navbar";
import PageTitle from "../../components/pagetitle";
import AboutProgress from "../../components/AboutProgress";
import ProgressVideo from "../../components/ProgressVideo";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import Logo from "../../images/logo-2.png";
import BuildingProcess from "../../components/BuildingProcess";

const ProgressPage = () => {
  return (
    <Fragment>
      <Navbar Logo={Logo} />
      <PageTitle pageTitle={"Progres"} pagesub={"Progres"} />
      <AboutProgress />
      <ProgressVideo />
      <BuildingProcess />
      <Footer ftClass={"wpo-site-footer-s2"} />
      <Scrollbar />
    </Fragment>
  );
};
export default ProgressPage;
